import type { SVGProps } from 'react';
export const ZoomIn = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path d="M11.62 8.93a.54.54 0 0 1-.54.54H9.47v1.61a.54.54 0 0 1-1.08 0V9.47H6.78a.54.54 0 1 1 0-1.08h1.61V6.78a.54.54 0 1 1 1.08 0v1.61h1.61a.54.54 0 0 1 .54.54m5.22 7.91a.54.54 0 0 1-.76 0l-3.36-3.36a5.92 5.92 0 1 1 .76-.76l3.36 3.36a.54.54 0 0 1 0 .76m-7.9-3.07a4.84 4.84 0 1 0 0-9.68 4.84 4.84 0 0 0 0 9.68" />
  </svg>
);
